/* eslint-disable */
import {times} from 'lodash'
export const bootinfo = () => {
    const str = 'CTPA v' + APP_VERSION;
    const decor = times(str.length, ()=>'=').join('');

    console.log(decor);
    console.log(str);
    console.log(decor);
};



// WEBPACK FOOTER //
// ./src/utils/bootinfo.js